import { html, render } from 'lit-html'
import { contextualize, cutlassEvent } from '@polleverywhere/cutlass'
import './join'
import Recent from './recent'
import '@polleverywhere/pe-graphic'
import '../../components/layout_plain'

import './style.scss'

export default class Home extends Backbone.View {
  get className () { return 'pollev-home' }

  get events () {
    return {
      'click:logout section-header': () => {
        this.trigger('navigate', 'logout')
      }
    }
  }

  initialize (options) {
    this.state = options.state
    this.lastPage = options.lastPage
    this.recent = new Recent()

    this.listenTo(this.recent, 'join', this.handleJoin)

    contextualize(this.el, 'home')
  }

  handleJoin (username, exists) {
    if (exists) {
      this.state.joinPresenterSession(username)
    }
    cutlassEvent(this.el, 'find_presenter', { successful: exists })
  }

  render () {
    render(html`<layout-plain>
      <main slot='content'>
        <pe-graphic aria-label='Poll Everywhere' role='img' class='polleverywhere-logo' type='legacy-svg' name='pe-logo-lockup-white'></pe-graphic>
        <pollev-home-join
          ?autofocus=${this.lastPage !== 'home'}
          @join=${event => this.handleJoin(event.detail.username, event.detail.exists)}
        ></pollev-home-join>
        ${this.recent.render().el}
      </main>
    </layout-plain>`, this.el)

    return this
  }

  remove () {
    this.recent.remove()

    super.remove()
  }
}
